import React, { useEffect, useRef } from "react";

export function MatrixRain({ className = "" }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const glyphs = "0123456789ABCDEF€$§↑↓✓·/\\|".split("");
    const fontSize = 14;
    let drops = [];
    let dpr = 1;

    const resize = () => {
      const parent = canvas.parentElement;
      if (!parent) return;
      const { width, height } = parent.getBoundingClientRect();
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.floor(width * dpr);
      canvas.height = Math.floor(height * dpr);
      canvas.style.width = `${width}px`;
      canvas.style.height = `${height}px`;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const columns = Math.floor(width / fontSize);
      drops = Array.from({ length: columns }, () => Math.floor((Math.random() * height) / fontSize));
    };
    resize();

    let raf = 0;
    let last = 0;
    const draw = (ts) => {
      const { width, height } = canvas.getBoundingClientRect();
      if (ts - last > 70) {
        last = ts;
        ctx.fillStyle = "rgba(10, 15, 24, 0.09)";
        ctx.fillRect(0, 0, width, height);
        ctx.font = `600 ${fontSize}px 'JetBrains Mono', monospace`;
        ctx.textBaseline = "top";
        for (let i = 0; i < drops.length; i++) {
          const char = glyphs[Math.floor(Math.random() * glyphs.length)];
          const x = i * fontSize;
          const y = drops[i] * fontSize;
          ctx.shadowColor = "rgba(212, 175, 95, 0.85)";
          ctx.shadowBlur = 8;
          ctx.fillStyle = "rgba(232, 205, 140, 0.95)";
          ctx.fillText(char, x, y);
          ctx.shadowBlur = 0;
          ctx.fillStyle = "rgba(212, 175, 95, 0.4)";
          ctx.fillText(glyphs[Math.floor(Math.random() * glyphs.length)], x, y - fontSize);
          if (y > height && Math.random() > 0.975) drops[i] = 0;
          drops[i]++;
        }
      }
      raf = requestAnimationFrame(draw);
    };
    if (!reduce) raf = requestAnimationFrame(draw);

    window.addEventListener("resize", resize);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return <canvas ref={canvasRef} aria-hidden="true" className={`pointer-events-none absolute inset-0 h-full w-full ${className}`} />;
}
